// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 登录 POST /hatch/vc/user/login
export const userLogin = (params) => {
    return postRequest('/videoclip/user/login', params)
};

// //videoclip/user/info
export const getUserInfo = (params) => {
    return getRequest('/videoclip/user/info', params)
};

// //videoclip/user/info
export const toLogout = (params) => {
    return getRequest('/videoclip/user/logout  ', params)
};

//注册 POST /hatch/vc/user/register
export const userRegister = (params) => {
    return postRequest('/videoclip/user/register', params)
};

//选择角色 POST /hatch/vc/user/addRole
export const userAddRole = (params) => {
    return postRequest('/videoclip/user/addRole', params)
};

//短信验证码登录 POST /hatch/vc/user/smsLogin
export const userSmsLogin = (params) => {
    return postRequest('/videoclip/user/smsLogin', params)
};

//获取短信验证码 POST /videoclip/user/sendSmsLogin
export const sendSmsLogin = (params) => {
    return postRequest('/videoclip/user/sendSmsLogin', params)
};

/**
 * 短信验证码是否注册验证 /hatch/vc/user/validateMobile 
 * @param 'mobile:string smsCode: string'
 */
export const userValidateMobile = (params) => {
    return postRequest('/videoclip/user/validateMobile ', params)
};





// WEBPACK FOOTER //
// ./src/api/login.js